document.addEventListener('DOMContentLoaded', function () {
  const mainImage = document.getElementById('product-main-image');
  const variantSelects = document.querySelectorAll('.variant-select');
  const priceElement = document.getElementById('product-price');
  const quantityInputs = document.querySelectorAll('.product-quantity-input');
  const decreaseButtons = document.querySelectorAll('.quantity-decrease');
  const increaseButtons = document.querySelectorAll('.quantity-increase');
  const thumbnails = document.querySelectorAll('.product-thumbnail');
  const shopCurrency = document.getElementById('shop-currency')?.value;
  const addToCartButtons = document.querySelectorAll('.add-to-cart-btn');
  const buttonTexts = document.querySelectorAll('.button-text');
  const loadingSpinners = document.querySelectorAll('.loading-spinner');
  const cartNotifications = document.querySelectorAll('.cart-notification');
  const errorNotifications = document.querySelectorAll('.error-notification');
  const productForm = document.getElementById('ProductForm');

  // Handle thumbnail clicks
  if (thumbnails.length > 0) {
    thumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        thumbnails.forEach((thumb) => thumb.classList.remove('active'));
        this.classList.add('active');
        const newImage = this.getAttribute('data-image');
        if (newImage && mainImage) {
          mainImage.style.opacity = '0.5';
          setTimeout(() => {
            mainImage.src = newImage;
            mainImage.style.opacity = '1';
          }, 200);
        }
      });
    });
  }

  // Handle variant selection
  variantSelects.forEach(function(variantSelect) {
    variantSelect.addEventListener('change', function () {
      const selectedOption = this.options[this.selectedIndex];
      if (!selectedOption) return;
      const newPrice = selectedOption.getAttribute('data-price');
      const newImage = selectedOption.getAttribute('data-image');
      const isAvailable = selectedOption.getAttribute('data-available') === 'true';
      if (newPrice && priceElement) {
        priceElement.textContent = formatMoney(newPrice, shopCurrency);
      }
      if (newImage && mainImage && newImage !== '') {
        mainImage.style.opacity = '0.5';
        setTimeout(() => {
          mainImage.src = newImage;
          mainImage.style.opacity = '1';
        }, 200);
        thumbnails.forEach((thumb) => {
          if (thumb.getAttribute('data-image') === newImage) {
            thumbnails.forEach((t) => t.classList.remove('active'));
            thumb.classList.add('active');
          }
        });
      }
      updateAddToCartButton(isAvailable);
    });
  });

  // Handle quantity decrease
  decreaseButtons.forEach(function(btn, index) {
    btn.addEventListener('click', function () {
      const input = quantityInputs[index];
      let quantity = parseInt(input.value, 10);
      if (quantity > 1) {
        input.value = quantity - 1;
      }
    });
  });

  // Handle quantity increase
  increaseButtons.forEach(function(btn, index) {
    btn.addEventListener('click', function () {
      const input = quantityInputs[index];
      let quantity = parseInt(input.value, 10);
      input.value = quantity + 1;
    });
  });

  // Validate quantity input
  quantityInputs.forEach(function(input) {
    input.addEventListener('change', function () {
      if (this.value < 1 || isNaN(this.value)) {
        this.value = 1;
      }
    });
  });

  // Handle form submission
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      showLoading(true);
      cartNotifications.forEach(n => n.classList.add('d-none'));
      errorNotifications.forEach(n => n.classList.add('d-none'));
      const formData = new FormData(productForm);
      const variantId = formData.get('id');
      const quantity = formData.get('quantity') || 1;
      
      if (!variantId) {
        errorNotifications.forEach(function(notification) {
          notification.textContent = 'Please select a product variant';
          notification.classList.remove('d-none');
        });
        showLoading(false);
        return;
      }
      
      addToCart(variantId, quantity);
    });
  }

  function updateAddToCartButton(isAvailable) {
    addToCartButtons.forEach(function(button, index) {
      if (buttonTexts[index]) {
        if (isAvailable) {
          button.disabled = false;
          buttonTexts[index].textContent = 'Lägg till i varukorgen';
        } else {
          button.disabled = true;
          buttonTexts[index].textContent = 'Slutsåld';
        }
      }
    });
  }

  function formatMoney(amount, currency) {
    return new Intl.NumberFormat('sv-SE', {
      style: 'currency',
      currency: currency || 'SEK',
    }).format(amount);
  }

  function showLoading(isLoading) {
    loadingSpinners.forEach(function(spinner) {
      if (isLoading) {
        spinner.classList.remove('d-none');
      } else {
        spinner.classList.add('d-none');
      }
    });
    addToCartButtons.forEach(function(button) {
      button.disabled = isLoading;
    });
  }

  function addToCart(variantId, quantity) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: parseInt(quantity) }],
      }),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((data) => {
            throw new Error(data.description || data.message || 'Error adding to cart');
          });
        }
        return response.json();
      })
      .then((data) => {
        updateCartCount();
        cartNotifications.forEach(n => n.classList.remove('d-none'));
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);
        errorNotifications.forEach(function(notification) {
          notification.textContent = error.message || 'Det uppstod ett problem när den här varan skulle läggas till i varukorgen. Försök igen.';
          notification.classList.remove('d-none');
        });
      })
      .finally(() => {
        showLoading(false);
      });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        // Update cart count badges
        const cartCountBadges = document.querySelectorAll('.cart-count-badge');
        const cartCountElements = document.querySelectorAll('.cart-count');
        
        if (cartCountBadges.length > 0) {
          cartCountBadges.forEach((badge) => {
            if (cart.item_count > 0) {
              badge.textContent = cart.item_count;
              badge.classList.remove('d-none');
            } else {
              badge.classList.add('d-none');
            }
          });
        }
        
        if (cartCountElements.length > 0) {
          cartCountElements.forEach((element) => {
            element.textContent = cart.item_count;
          });
        }
        
        // Dispatch custom event for cart counter
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: cart }
        }));
      })
      .catch((error) => {
        console.error('Error fetching cart:', error);
      });
  }
});
